export enum DetailsSections {
    Registry = "registry",
    Offices = "offices",
    Accounting = "accounting",
    AntimoneyLaundering = "antimoneylaundering",
    Business = "business",
    Intrastat = "intrastat",
    Banks = "creditlines",
    Intermediaries = "intermediaries",
    F24 = "f24"
}
